import { closeActivePopup } from "@client/actions";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getCompositeSettingSelector, makeAnimationOptionsSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { type EntityContainerProps } from "@client/viewer/layout/Entity/Container/container";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeCloseButtonStyleSelector, makeStyleSelector } from "./selectors";

type PopupComponentProps = {
  id: string;
  keepOpenOnOverlayClick?: boolean;
  topMenu?: any;
};

export type PopupComponent = React.ComponentType<PopupComponentProps>;

export type PopupProps = EntityRef & {
  canClose: boolean;
  className?: string;
  entityStyle?: React.CSSProperties;
  keepOpenOnOverlayClick?: boolean;
  style?: React.CSSProperties;
  topMenu?: any;
  EntityContainer?: React.ComponentType<EntityContainerProps>;
};
const makeMapStateToProps = () => {
  const animationOptionsSelector = makeAnimationOptionsSelector(TargetSelector.Entity);
  const closeButtonStyleSelector = makeCloseButtonStyleSelector();
  const closeButtonSelector = getCompositeSettingSelector<{ icon: string }>(TargetSelector.Entity, "closeButton");
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: PopupProps): MapProps => {
    const closeButton = closeButtonSelector(state, props);

    return {
      ...props,
      ...closeButtonSelector(state, props),
      animationOptions: animationOptionsSelector(state, props),
      canClose: props.canClose,
      closeButtonIcon: closeButton?.icon,
      closeButtonStyle: closeButtonStyleSelector(state, props),
      style: styleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any): ActionProps => ({
  close: () => dispatch(closeActivePopup())
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps, { forwardRef: true })(Component);
